const convertControlsToCSS = (controls) => ({
    '--controls-placeholder-default': controls.placeholder.default,
    '--controls-placeholder-action': controls.placeholder.action,
    '--controls-placeholder-active': controls.placeholder.active,
    '--controls-placeholder-active-action': controls.placeholder.activeAction,
    '--controls-caret-default': controls.caret.default,
    '--controls-caret-action': controls.caret.action,
    '--controls-caret-active': controls.caret.active,
    '--controls-caret-active-action': controls.caret.activeAction,
    '--controls-border-default': controls.border.default,
    '--controls-border-action': controls.border.action,
    '--controls-border-active': controls.border.active,
    '--controls-border-active-action': controls.border.activeAction,
    '--controls-background-default': controls.background.default,
    '--controls-background-action': controls.background.action,
    '--controls-background-active': controls.background.active,
    '--controls-background-active-action': controls.background.activeAction,
    '--controls-value-default': controls.value.default,
    '--controls-value-action': controls.value.action,
    '--controls-value-active': controls.value.active,
    '--controls-value-active-action': controls.value.activeAction,
    '--controls-text-default': controls.text.default,
    '--controls-text-action': controls.text.action,
    '--controls-text-active': controls.text.active,
    '--controls-text-active-action': controls.text.activeAction,
    '--controls-start-icon-default': controls.startIcon.default,
    '--controls-start-icon-action': controls.startIcon.action,
    '--controls-start-icon-active': controls.startIcon.active,
    '--controls-start-icon-active-action': controls.startIcon.activeAction,
    '--controls-end-icon-default': controls.endIcon.default,
    '--controls-end-icon-action': controls.endIcon.action,
    '--controls-end-icon-active': controls.endIcon.active,
    '--controls-end-icon-active-action': controls.endIcon.activeAction,
    '--controls-slider-thumb-default': controls.sliderThumb.default,
    '--controls-slider-thumb-action': controls.sliderThumb.action,
    '--controls-slider-thumb-active': controls.sliderThumb.active,
    '--controls-slider-thumb-active-action': controls.sliderThumb.activeAction,
    '--controls-slider-track-default': controls.sliderTrack.default,
    '--controls-slider-track-action': controls.sliderTrack.action,
    '--controls-slider-track-active': controls.sliderTrack.active,
    '--controls-slider-track-active-action': controls.sliderTrack.activeAction,
});
const convertControlsToObject = (controls) => ({
    controlsPlaceholderDefault: controls.placeholder.default,
    controlsPlaceholderAction: controls.placeholder.action,
    controlsPlaceholderActive: controls.placeholder.active,
    controlsPlaceholderActiveAction: controls.placeholder.activeAction,
    controlsCaretDefault: controls.caret.default,
    controlsCaretAction: controls.caret.action,
    controlsCaretActive: controls.caret.active,
    controlsCaretActiveAction: controls.caret.activeAction,
    controlsBorderDefault: controls.border.default,
    controlsBorderAction: controls.border.action,
    controlsBorderActive: controls.border.active,
    controlsBorderActiveAction: controls.border.activeAction,
    controlsBackgroundDefault: controls.background.default,
    controlsBackgroundAction: controls.background.action,
    controlsBackgroundActive: controls.background.active,
    controlsBackgroundActiveAction: controls.background.activeAction,
    controlsValueDefault: controls.value.default,
    controlsValueAction: controls.value.action,
    controlsValueActive: controls.value.active,
    controlsValueActiveAction: controls.value.activeAction,
    controlsStartIconDefault: controls.startIcon.default,
    controlsStartIconAction: controls.startIcon.action,
    controlsStartIconActive: controls.startIcon.active,
    controlsStartIconActiveAction: controls.startIcon.activeAction,
    controlsEndIconDefault: controls.endIcon.default,
    controlsEndIconAction: controls.endIcon.action,
    controlsEndIconActive: controls.endIcon.active,
    controlsEndIconActiveAction: controls.endIcon.activeAction,
    controlsSliderThumbDefault: controls.sliderThumb.default,
    controlsSliderThumbAction: controls.sliderThumb.action,
    controlsSliderThumbActive: controls.sliderThumb.active,
    controlsSliderThumbActiveAction: controls.sliderThumb.activeAction,
    controlsSliderTrackDefault: controls.sliderTrack.default,
    controlsSliderTrackAction: controls.sliderTrack.action,
    controlsSliderTrackActive: controls.sliderTrack.active,
    controlsSliderTrackActiveAction: controls.sliderTrack.activeAction,
});
const Controls = {
    placeholder: {
        default: 'var(--controls-placeholder-default)',
        action: 'var(--controls-placeholder-action)',
        active: 'var(--controls-placeholder-active)',
        activeAction: 'var(--controls-placeholder-active-action)',
    },
    caret: {
        default: 'var(--controls-caret-default)',
        action: 'var(--controls-caret-action)',
        active: 'var(--controls-caret-active)',
        activeAction: 'var(--controls-caret-active-action)',
    },
    border: {
        default: 'var(--controls-border-default)',
        action: 'var(--controls-border-action)',
        active: 'var(--controls-border-active)',
        activeAction: 'var(--controls-border-active-action)',
    },
    background: {
        default: 'var(--controls-background-default)',
        action: 'var(--controls-background-action)',
        active: 'var(--controls-background-active)',
        activeAction: 'var(--controls-background-active-action)',
    },
    value: {
        default: 'var(--controls-value-default)',
        action: 'var(--controls-value-action)',
        active: 'var(--controls-value-active)',
        activeAction: 'var(--controls-value-active-action)',
    },
    text: {
        default: 'var(--controls-text-default)',
        action: 'var(--controls-text-action)',
        active: 'var(--controls-text-active)',
        activeAction: 'var(--controls-text-active-action)',
    },
    startIcon: {
        default: 'var(--controls-start-icon-default)',
        action: 'var(--controls-start-icon-action)',
        active: 'var(--controls-start-icon-active)',
        activeAction: 'var(--controls-start-icon-active-action)',
    },
    endIcon: {
        default: 'var(--controls-end-icon-default)',
        action: 'var(--controls-end-icon-action)',
        active: 'var(--controls-end-icon-active)',
        activeAction: 'var(--controls-end-icon-active-action)',
    },
    sliderThumb: {
        default: 'var(--controls-slider-thumb-default)',
        action: 'var(--controls-slider-thumb-default-action)',
        active: 'var(--controls-slider-thumb-default-active)',
        activeAction: 'var(--controls-slider-thumb-default-active-action)',
    },
    sliderTrack: {
        default: 'var(--controls-slider-track-default)',
        action: 'var(--controls-slider-track-action)',
        active: 'var(--controls-slider-track-active)',
        activeAction: 'var(--controls-slider-track-active-action)',
    },
};

export { Controls, convertControlsToCSS, convertControlsToObject };
